import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Checkbox, Form, Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { validateEmail } from "../../Helpers/Validators";
import { TextService } from "../../Services/TextService";


export const BookyCheckboxList = (props: any) => {
    const GetText = TextService.GetText;

    const rules: any = [];
    if (props.req) {
        rules.push({
            required: true,
            message: props.requiredMessage || GetText("EditMember_Mandatory"),
            validator: (_: any, value: any) => {
                if (value && value.length > 0) {
                    return Promise.resolve();
                }
                return Promise.reject(new Error(props.requiredMessage || GetText("EditMember_Mandatory")));
            },
        });
    }

    return (

        <Form.Item label={props.label} name={props.name} rules={rules}
        >
            <Checkbox.Group
                data-testid={props.name + "-checkbox-list"}
                options={props.options}
                onChange={props.onChange}
            />
        </Form.Item>
    );

}